'use client'

import { useAuthStore } from '@/stores/useAuthStore'

/**
 * Sessão aberta pelo atendente (`login-as-customer`): esconde o pagamento no checkout e mostra a faixa "Acesso de
 * suporte". Lê a useAuthStore (o service marca `supportAccess` junto do cookie `@glofi:support`); na hidratação vale o
 * estado inicial da store, igual ao do servidor.
 */
export function useSupportAccess(): boolean {
    return useAuthStore((state) => state.data?.supportAccess === true)
}
